<template>
  <!-- 评论列表 -->
  <div class="comment-list">
    <div class="chat_total">评论列表（{{ total }}条）</div>
    <div class="item u-flex" v-for="(item,index) of  commentArray" v-if="item.showStatus==1">
      <div class="avatar">
        <el-image style="width: 55px; height: 55px;border-radius: 50%;" :src="item.user_avatar" fit="cover"/>
      </div>
      <div class="box">
        <p class="userName">{{ item.user_name }}</p>
        <p class="content">{{ item.content }}</p>
        <div class="tools u-flex u-row-between">
          <div style="display: flex;">
            <span>{{ item.time }}</span>
            <span style="margin-left:20px" class="finger" @click="commentDelMethod(item.id)"
                  v-if="item.mid == cid">删除</span>
            <el-popover placement="right" width="400" v-else @click.native="currentComment = item.id" trigger="click">
              <span style="margin-left:20px" class="finger" slot="reference">举报</span>
              <div class="jubao_content">
                <div>请选择举报原因</div>
                <div>
                  <span v-for="(item1,index1) in jubao" :key="index1" @click="complain(item1)">{{ item1 }}</span>
                </div>
              </div>
            </el-popover>
          </div>
          <div class="u-flex right-btn">
            <div class="u-flex openReply" @click="openReply(item)">
              <img class="zan" src="@/assets/img/home/com.png" alt="">
              <span>{{ item.openReply ? '取消回复' : '回复' }}</span>
            </div>
            <div class="u-flex finger" style="margin-left:30px" @click="commentFabulousMethod(item)">
              <img class="zan" src="@/assets/img/home/ic_dynamic_dz_false.png" v-if="!item.is_fabulous">
              <img class="zan" src="@/assets/img/home/赞.png" v-else>
              <span :class="{isDianzan : item.fabulous_count}">{{ item.fabulous_count==0 ? '赞' : item.fabulous_count }}</span>
            </div>
          </div>
        </div>
        <div class="reply-box" v-show="item.openReply">
          <el-input v-model="item.replyTxt">
            <template slot="prepend">回复{{item.user_name}}：</template>
          </el-input>
          <div class="btn" @click="reply(item.replyTxt,item.id)">回复</div>
        </div>
        <!-- 子级评论 -->
        <div class="reply_infoList" v-if="item.reply">
          <template v-for="(row,index) in  item.reply">
            <div class="item u-flex" v-if="index<2">
              <div class="avatar">
                <el-avatar :size="54" :src="row.user_avatar"/>
              </div>
              <div class="box">
                <p class="userName">{{ row.user_name }}</p>
                <p class="content">{{ row.content }}</p>
                <div class="tools u-flex u-row-between">
                  <div style="display: flex;">
                    <span>{{ row.time }}</span>
                    <span style="margin-left:20px" class="finger" @click="commentDelMethod(row.id)" v-if="row.mid == cid">删除</span>
                    <el-popover placement="right" width="400" v-else @click.native="currentComment = row.id" trigger="click">
                      <span style="margin-left:20px" class="finger" slot="reference">举报</span>
                      <div class="jubao_content">
                        <div>请选择举报原因</div>
                        <div>
                          <span v-for="(item2,index2) in jubao" :key="index2" @click="complain(item2,row)">{{item2}}</span>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                  <div class="u-flex right-btn">
                    <div class="u-flex finger" style="margin-left:30px" @click="commentFabulousMethod(row)">
                      <img class="zan" src="@/assets/img/home/ic_dynamic_dz_false.png" v-if="!row.is_fabulous">
                      <img class="zan" src="@/assets/img/home/赞.png" v-else>
                      <span :class="{isDianzan : row.fabulous_count}">{{ row.fabulous_count || '赞' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item u-flex" v-if="index>=2 && showAll">
              <div class="avatar">
                <el-avatar :size="54" :src="row.user_avatar"/>
              </div>
              <div class="box">
                <p class="userName">{{ row.user_name }}</p>
                <p class="content">{{ row.content }}</p>
                <div class="tools u-flex u-row-between">
                  <div style="display: flex;">
                    <span>{{ row.time }}</span>
                    <span style="margin-left:20px" class="finger" @click="commentDelMethod(row.id)" v-if="row.mid == cid">删除</span>
                    <el-popover placement="right" width="400" v-else @click.native="currentComment = row.id"
                                trigger="click">
                      <span style="margin-left:20px" class="finger" slot="reference">举报</span>
                      <div class="jubao_content">
                        <div>请选择举报原因</div>
                        <div>
                          <span v-for="(item2,index2) in jubao" :key="index2" @click="complain(item2,row)">{{item2}}</span>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                  <div class="u-flex right-btn">
                    <div class="u-flex finger" style="margin-left:30px" @click="commentFabulousMethod(row)">
                      <img class="zan" src="@/assets/img/home/ic_dynamic_dz_false.png" v-if="!row.is_fabulous">
                      <img class="zan" src="@/assets/img/home/赞.png" v-else>
                      <span :class="{isDianzan : row.fabulous_count}">{{ row.fabulous_count || '赞' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <p @click="showMore" v-if="!showAll && item.reply < 3" class="more-replay u-flex">
            <span>全部{{ item.reply_count }}条回复</span>
            <i class="el-icon-arrow-down"/>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {commentFabulous, commentDel, commentReport, report, recommendLists} from '@/api/interfaceApi'
export default {
  data() {
    return {
      jubao: ['内容违法', '色情低俗', '谩骂攻击', '广告营销'],
      currentComment: null, //记录点击举报的评论id
      getMorePage: 1, //获取更多评论的页码
      showAll:false,
      cid:0,
    };
  },
  props: {
    commentArray: {
      type: Array,
      default() {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    details:{
      type:Object,
      default() {
        return {};
      }
    }
  },
  mounted() {},
  methods: {
    openReply(row) {
      this.$set(row, 'openReply', !row.openReply);
    },
    //显示更多
    showMore(item, index) {
      this.showAll=true;
    },
    // 点击回复评论
    reply(content, id) {
      if (!content) { //无评论不请求
        return
      }
      let cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
      if (!cid) { //未登录 提示登录
        this.$message.warning('请登录后操作')
        return
      }
      let obj = {content: content, id: id}
      this.$emit('reply', obj)
    },
    // 点赞/取消点赞
    commentFabulousMethod(row) {
      let obj = {
        aid: this.details.id, //文章id
        comment_id: row.id, //评论id
        uid:row.mid
      }
      commentFabulous(obj).then((res) => {
        if (res.code == 200) {
          if (res.content.status) {
            this.$message.success(res.msg)
            row.fabulous_count += 1
            row.is_fabulous = 1
          } else {
            this.$message.success(res.msg)
            row.fabulous_count -= 1
            row.is_fabulous = 0
          }
          this.$emit('dianzan')
        }
      })
    },
    // 点击举报
    complain(text,row) {
      this.$confirm('确定要举报该评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.commentReportMethod(text,row)
      }).catch(() => {})
    },
    // 网络请求 举报评论
    commentReportMethod(content,row) {
      let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      let obj = {
        article_id: row.id,
        type: 4,
        content: content,
        uid: cid!=0 && cid!=undefined ? cid : 0
      }
      report(obj).then(res => {
        if (res.code == 200) {
          this.$message.success('举报成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 网络请求 删除评论
    commentDelMethod(id) {
      let obj = {comment_id: id}
      this.$confirm('确定要删除该条评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         commentDel(obj).then((res) => {
           if (res.code == 200) {
             this.$message.success(res.msg)
             this.$emit('dianzan')
           }else{
             this.$message.error(res.msg)
           }
         })
      }).catch(() => {
      });
    }
  },
  beforeMount() {
    let cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.cid=cid!=0 && cid!=undefined ? cid : 0
  }
};
</script>
<style lang="scss" scoped>
.comment-list {
  margin-top: 60px;

  .item {
    align-items: flex-start;
    display: flex;
    padding-bottom: 30px;

    .avatar {
      margin-right: 20px
    }

    .box {
      flex: 1;

      .userName {
        font-size: 16px;
        font-family: 'SourceHanSansCN';
        padding-top: 0;
      }

      .content {
        padding-bottom: 5px;
        font-size: 16px;
      }

      .tools {
        font-size: 14px;
        color: #999999;
        display: flex;
        justify-content: space-between;
        .right-btn{
          display: flex;
        }
        .finger{
          cursor: pointer;
          display: flex;
          align-items: center;
        }
        .zan {
          width: 15px;
          margin-right: 6px;
        }

        .openReply {
          cursor: pointer;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.reply-box {
  position: relative;
  margin-top: 16px;
  display: flex;
  align-items: stretch;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;

  .btn {
    width: 110px;
    background: #222222;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
  }
}

.reply_infoList {
  padding-top: 35px;

  .more-replay {
    font-size: 14px;
    color: #333;
    cursor: pointer;
    margin-left: 72px;
  }
}

.isDianzan {
  color: #FE273B;
}

.jubao_content {
  font-size: 16px;
  font-weight: 100;
  color: #333333;

  > div:nth-child(1) {
    width: 100%;
    text-align: center;
    font-size: 18px;
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > span {
      display: inline-block;
      width: 133px;
      height: 38px;
      border-radius: 19px;
      border: 1px solid #DDDDDD;
      text-align: center;
      line-height: 38px;
      margin: 10px 25px;
      cursor: pointer;

      &:hover {
        background-color: #FD2F37;
        border: 1px solid #FD2F37;
        color: #fff;
      }
    }
  }
}

.chat_total {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 20px;
}
</style>
<style scoped>
.reply-box >>> .el-input__inner {
  border: 0;
  height: 52px;
}
</style>
<style>
.reply-box .el-input-group__append, .el-input-group__prepend {
  background-color: #ffffff;
  color: #999999;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: none;
  border-radius: 4px;
  padding: 0 10px;
  width: 1px;
  white-space: nowrap;
}
.reply-box .el-input__inner {
  color: #333333;
  padding: 0 0px;
}
</style>